/**
 * The meal a log goes to when the user didn't pick one (center + button,
 * Say or Type, a scan, saved foods, a recipe's Add to Diary). A meal row's +
 * always wins over this. WEB COPY of mobile utils/mealTime.ts.
 *
 * Uses the diary's own time ranges (`diary.timeRanges`): breakfast 6–10am,
 * lunch 11am–2pm, dinner 5–9pm, snack anytime. The end hour counts in full
 * (10:45 is still breakfast, 9:30pm still dinner); the gaps between the
 * ranges (3–5pm, 10pm–6am) are snack time.
 */

import type { MealTime } from '@/types'

const MEAL_TIMES: readonly MealTime[] = ['breakfast', 'lunch', 'dinner', 'snack']

/** The meal for a local time (default: now). */
export function getMealTypeForTime(date: Date = new Date()): MealTime {
  const hour = date.getHours()
  if (hour >= 6 && hour <= 10) return 'breakfast'
  if (hour >= 11 && hour <= 14) return 'lunch'
  if (hour >= 17 && hour <= 21) return 'dinner'
  return 'snack'
}

/** A route param / stored value that names a meal, or undefined. */
export function asMealTime(value: unknown): MealTime | undefined {
  return MEAL_TIMES.includes(value as MealTime) ? (value as MealTime) : undefined
}
